import React from 'react';
export function FooterSection() {
  return <footer className="bg-neutral-950 py-8 md:py-12 border-t border-neutral-900 text-center" data-id="element-114">
      <div className="container mx-auto px-4" data-id="element-115">
        <h2 className="text-lg md:text-2xl font-black text-white mb-1 md:mb-2 flex items-center justify-center gap-2" data-id="element-116">
          🎵 RITMOS LATINOS RESUELTO™
        </h2>
        <p className="text-neutral-400 text-xs md:text-base mb-4 md:mb-8 max-w-md mx-auto leading-snug" data-id="element-117">
          El sistema de clases N°1 para profes de ritmos latinos en Argentina.
          <br data-id="element-118" />
          <br data-id="element-119" />
          Porque enseñar ritmos latinos no debería costarte todas las noches de
          la semana.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-8 text-xs md:text-sm text-neutral-500 mb-4 md:mb-8" data-id="element-120">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-amber-500 transition-colors" data-id="element-121">
            contacto@recursosfitness.shop
          </a>
          <span className="hidden md:inline" data-id="element-122">•</span>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-123">
            @recursosfitness.ar
          </a>
          <span className="hidden md:inline" data-id="element-124">•</span>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-125">
            recursosfitness.shop
          </a>
        </div>

        <p className="text-[10px] md:text-xs text-neutral-600" data-id="element-126">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}